import {
  RequestMaterialFormData,
  RequestMaterialLine,
} from './types';

export const requestMaterialStatuses = [
  { id: 'all', name: 'Tất cả trạng thái' },
  { id: 'request', name: 'Yêu cầu vật tư' },
  { id: 'submitted', name: 'Đã gửi' },
  { id: 'approved', name: 'Đã duyệt' },
  { id: 'canceled', name: 'Đã hủy' },
];

export const requestMaterialFormStatuses = [
  { id: 'request', name: 'Yêu cầu vật tư' },
  { id: 'submitted', name: 'Đã gửi' },
  { id: 'approved', name: 'Đã duyệt' },
  { id: 'canceled', name: 'Đã hủy' },
];

export const requestMaterialTypeOptions = [
  { id: 'all', name: 'Tất cả loại request' },
  { id: 'order', name: 'Vật tư cho đơn hàng' },
  { id: 'reserve', name: 'Vật tư cho dự trữ' },
];

const line = (input: Partial<RequestMaterialLine> & Pick<RequestMaterialLine, 'id' | 'line_type'>): RequestMaterialLine => ({
  sort_order: input.id,
  requested_qty: 0,
  ...input,
});

const toLocalDateString = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const createDefaultRequestMaterialForm = (companyId: string): RequestMaterialFormData => {
  const requestedAt = new Date();
  const requiredBy = new Date(requestedAt);
  requiredBy.setDate(requiredBy.getDate() + 1);

  return {
    request_type: 'order',
    company_id: companyId,
    warehouse_id: '',
    order_id: '',
    order_search: '',
    note: '',
    status: 'request',
    requested_at: toLocalDateString(requestedAt),
    required_by: toLocalDateString(requiredBy),
    requested_by_id: null,
    lines: [
      line({ id: Date.now(), line_type: 'item', requested_qty: 1 }),
    ],
  };
};

